module.exports = __webpack_public_path__ + "opensans-light.11bbcff6f99be028bf04.woff";


//////////////////
// WEBPACK FOOTER
// E:/PROJETO SUFRAMA/DESENVOLVIMENTO/Projetos/SCIEX/sciex/src/Suframa.Sciex.UserInterface/www/assets/fonts/opensans/opensans-light.woff
// module id = ../../../../../www/assets/fonts/opensans/opensans-light.woff
// module chunks = styles